'use strict';

function PhoneVerification() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.onComplete = function () {};
  this.onInit = function () {};
  this.onSubmittedPhone = function () {};
  this.onEditPhone = function () {};
  this.prefill = false; // Prefill with account phone number
  this.summaryMode = false; // Show in summary mode. If true, prefill defaults to true.

  this._baseClassName = 'form-wizard__section';
  this.states = {
    passive: this._baseClassName + '--passive',
    edit: this._baseClassName + '--edit',
    change: this._baseClassName + '--change',
    summary: this._baseClassName + '--summary'
  };
  this._isComplete = false;
  this._savedNumber = '';

  this.init = function () {
    this.optionsSection = $('.mogo-page-phone-verification__options', this.node);
    this.verifySection = $('.mogo-page-phone-verification__verify', this.node);
    this.contactForm = $('.mogo-page-phone-verification__options__contact-form', this.node);
    this.verifyMethodInput = $("[name='verification_method']", this.node);
    this.verifyDefaultAlert = $('.alert-default', this.verifySection);
    this.verifyCallAlert = $('.alert-call', this.verifySection);
    this.verifySMSAlert = $('.alert-sms', this.verifySection);
    this.visibleCall = $('.visible-call', this.verifySection);
    this.visibleSMS = $('.visible-sms', this.verifySection);
    this.editIconOptions = $('.mogo-page-phone-verification__options a.icon--edit', this.node);
    this.cancelEdit = $('.mogo-page-phone-verification__options__cancel', this.node);
    this.verifyForm = $('.mogo-page-phone-verification__verify form', this.node);
    this.verificationPin = $('.mogo-page-phone-verification__verification_pin', this.node);
    this.phoneNumber = $('.mogo-page-phone-verification__phone_number', this.node);
    this.voiceLink = $('.phone-verification__voice-link', this.node);
    this.textLink = $('.phone-verification__text-link', this.node);
    this.notifications = $('#Notification').mogo();

    this._phoneNumbers = new PhoneNumbers(this.presenter, this._onPhoneNumbersLoad.bind(this));

    var ds = new DataSanitization();
    this.presenter.extendCustomValidations('account.phone_number_create', {
      phone_number: {
        sanitize: function sanitize(value) {
          return value;
        }
      }
    });

    var viewMap = {
      'account.verification_method': {
        set: function set(value) {
          return typeof value === 'string' ? value : value[0];
        }
      }
    };
    // the if condition can be removed once phone_number is permanent on create_profile
    viewMap['account.phone_number'] = {
      set: function set(value) {
        return String(value == null ? '' : value).replace(/\D/g, '').substring(0, 10);
      },
      get: function get(value) {
        return String(value == null ? '' : value).replace(/\D/g, '').substring(0, 10);
      }
    };

    this.presenter.extendViewMap(viewMap);

    // Callbacks
    this._submitPhoneCallback = this.presenter.addCallbackToAction('account.phone_number_create', $.proxy(this._onSubmitNewPhone, this));
    this._verifyPhoneCallback = this.presenter.addCallbackToAction('account.phone_number_verify', $.proxy(this._onVerifyNewPhone, this));

    // Event listeners
    this.voiceLink.on('click', this._resendCode.bind(this, 'call'));
    this.textLink.on('click', this._resendCode.bind(this, 'sms'));
    this.editIconOptions.on('click', this._pageView.bind(this, 'validated-edit'));
    this.cancelEdit.on('click', this._pageView.bind(this, 'options-verified'));

    // Computed variables
    if (this.summaryMode) this.prefill = true;
    if (this.prefill && this.presenter.models.account.phone_number) {
      this.presenter.createModel('phone', {
        data: {
          phone_number: this.presenter.models.account.phone_number
        }
      });
      this._savedNumber = this.presenter.models.account.phone_number;

      if (this.summaryMode) {
        this._isComplete = true;
        this._pageView('options-verified');
        this._pageView('pin-verified');
      }
    } else {
      this.presenter.createModel('phone', { data: null });
    }
  };

  this.initAllReady = function () {
    this.contactForm.removeClass('hide');
    this.analytics.pushEvent('phone-verification', { PhoneVerification: ['Required'] });
  };

  this._onPhoneNumbersLoad = function () {
    this._savedNumber = this._phoneNumbers.getCurrentNumber();

    // Pre-populate step one (Get Verification code) when data is ready
    this._setupComputedVariable();

    if (this._savedNumber) {
      this.phoneNumber.mogo().val(this._savedNumber);
      this.analytics.pushEvent('phone-verification', { PhoneVerification: ['Prepopulated'] });
    }

    this._onInit();
  };

  this._onInit = function () {
    $(this.node).find('.mogo-page-phone-verification').removeClass('hide');
    $(this.node).find('.mogo-page-phone-verification-loader').addClass('hide');
    this.onInit();
  };

  this._setupComputedVariable = function () {
    var _this = this;

    this.presenter.addComputedVariable('phone_number', ['phone.phone_number'], function (val) {
      // If there's no validated number ,  using method in PhoneNumbers to get current number from account_phone_numbers model
      var currentNumber = val || _this._phoneNumbers.getCurrentNumber();

      return Formatters.formatPhone(currentNumber);
    });
  };

  this._onVerifyNewPhone = function (data, response) {
    if (response == 200 && data.verification_status == 'verified') {
      this.analytics.pushEvent('phone-verification', { PhoneVerification: ['Verified'] });
      this.presenter.updateModel('phone', data);
      this.presenter.updateModel('account', null, $.proxy(function () {
        this._pageView('pin-verified');
        this.onComplete();
      }, this));
      this.presenter.updateModel('account_phone_numbers');
      this._isComplete = true;
    } else if (data.errors[0].key == 'member_service_incorrect_pin') {
      this.analytics.forcePushEvent('form-errors', { FormErrors: ['verification_pin'] });
    } else {
      this.notifications.get();
    }
  };

  this._onSubmitNewPhone = function (data, response) {
    if (response == 200) {
      this._savedNumber = this.presenter.models.phone.phone_number;
      this._isComplete = false;

      // Need to parsePhoneNumber to populate the computed property when model is updated
      this.presenter.updateModel('account_phone_numbers', null, this._phoneNumbers.parsePhoneNumbersModel.bind(this._phoneNumbers));
      this.presenter.updateModel('phone', data, $.proxy(this._pageView, this, 'submit-new-phone'));
      this.presenter.updateModel('account', null, $.proxy(this.presenter.scanDOM, this.presenter, this.node)); // update the rel links and scanDOM after

      this._resetMessageVisibility();
      if (data.verification_method == 'sms') {
        this.visibleSMS.removeClass('hide');
        this.analytics.forcePushEvent('phone-verification', { PhoneVerification: ['Text'] });
      } else {
        this.visibleCall.removeClass('hide');
        this.analytics.forcePushEvent('phone-verification', { PhoneVerification: ['Voice'] });
      }
      setTimeout($.proxy(this._switchAlertMessage, this, data.verification_method), 120000);
      if (this.onSubmittedPhone) {
        this.onSubmittedPhone();
      }
    } else if (response == 400 && data.errors[0].key == 'member_service_not_ready_for_resend') {
      // Nulls the input fieldErrors and collapses the verification section
      // Currently, SchemaValidation prevents forms from being submitted if there are fieldErrors
      // TODO: SchemaValidation clear fieldErrors method?
      this.phoneNumber.trigger('change');
      this._changeState(this.optionsSection, this.states.summary);
      this._changeState(this.verifySection, this.states.edit);

      this.notifications.create({
        type: 'warning',
        msg: 'Hold on, give it 2 minutes before trying again.'
      });
    } else if (response === 400 && data.errors[0].key === 'telesign_service_invalid_number_error') {
      // important: This resolves issue with subsequent resend attempts (see pr for details).
      this.phoneNumber.trigger('change');

      // note: Backend error message is displayed when the phone number is non-Canadian or VOIP.
      this.notifications.create({
        type: 'warning',
        msg: data.errors[0].msg
      });
    } else if (response == 400 && data.errors[0].key == 'telesign_service_error') {
      this.analytics.forcePushEvent('form-errors', { FormErrors: ['phone_number'] });
    } else {
      this.notifications.get();
    }
  };

  this._resetMessageVisibility = function () {
    this.verifyDefaultAlert.removeClass('hide');
    this.verifySMSAlert.addClass('hide');
    this.verifyCallAlert.addClass('hide');
    this.visibleSMS.addClass('hide');
    this.visibleCall.addClass('hide');
  };

  this._switchAlertMessage = function (verificationMethod) {
    this.verifyDefaultAlert.addClass('hide');
    if (verificationMethod === 'sms') {
      this.verifySMSAlert.removeClass('hide');
    } else {
      this.verifyCallAlert.removeClass('hide');
    }
  };

  this._resendCode = function (type) {
    this.verifyMethodInput.mogo().val(type);
    this.contactForm.submit();
  };

  this._pageView = function (view) {
    this._savedNumber = this._phoneNumbers.getCurrentNumber();

    if (view === 'options-verified') {
      this._changeState(this.optionsSection, this.states.summary);
      if (this.presenter.models.account.phone_number && this._isComplete) {
        if (typeof this.onComplete === 'function') this.onComplete();
      } else {
        this._changeState(this.verifySection, this.states.edit);
      }
      this.phoneNumber.mogo().val(this._savedNumber);
      this.phoneNumber.trigger('change');
      // Reset Message
      this._resetMessageVisibility();
    } else if (view === 'pin-verified') {
      this._changeState(this.verifySection, this.states.summary);
    } else if (view === 'validated-edit') {
      // clear the pin
      this.verificationPin.mogo().val('');
      if (this.verifyForm.mogo().declaredClass) this.verifyForm.mogo().resetValidationField('verification_pin');
      this._changeState(this.optionsSection, this.states.change);
      if (this.presenter.models.account.phone_number && this._isComplete) this._changeState(this.verifySection, this.states.summary);else this._changeState(this.verifySection, this.states.passive);
      if (typeof this.onEditPhone === 'function') this.onEditPhone();
    } else if (view == 'submit-new-phone') {
      this._changeState(this.optionsSection, this.states.summary);
      this._changeState(this.verifySection, this.states.edit);
    } else {
      console.error(view + ' is an invalid view');
    }
  };

  this._changeState = function (element, newState) {
    var elementState = element.attr('class');
    if (elementState != newState) {
      element.switchClass(elementState, newState);
    }
  };

  /*
    isPhoneValidated: Booleen and checks
    if a phone is validated.
  */
  this.isPhoneValidated = function () {
    // Phone number is verified when account model has phone_number property
    return !!this.presenter.getModelProperty('account.phone_number');
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('phone_number');

    this._phoneNumbers.destroyClass();

    this.presenter.removeCallbackFromAction('account.phone_number_create', this._submitPhoneCallback);
    this.presenter.removeCallbackFromAction('account.phone_number_verify', this._verifyPhoneCallback);

    this.voiceLink.off('click', this._resendCode);
    this.textLink.off('click', this._resendCode);
    this.editIconOptions.off('click', this._pageView);
    this.cancelEdit.off('click', this._pageView);
  };
}